// cc-swatch-click.js — Collection page swatch click-to-swap behavior
// Loaded after app.js; handles button-based .cc-swatch elements in the draft theme.

document.addEventListener('DOMContentLoaded', function () {
  if (!window.PXUTheme || !window.PXUTheme.theme_settings.collection_swatches) return;

  // Click: swap product card image + update caption href + mark active swatch
  $('body').on('click', '.cc-swatch', function () {
    var $btn       = $(this);
    var swapImg    = $btn.data('swap-image');
    var variantUrl = $btn.data('variant-url');
    var $card      = $btn.closest('.thumbnail, .js-recently-viewed-product');

    if (swapImg) {
      $card.find('.image__container img:not(.secondary)')
           .attr('src', swapImg)
           .attr('srcset', swapImg);
    }
    if (variantUrl) {
      $card.find('a.product-info__caption').attr('href', variantUrl);
    }

    $btn.closest('.cc-swatch-strip').find('.cc-swatch').removeClass('cc-active');
    $btn.addClass('cc-active');
  });

  // Desktop hover: preload image + swap immediately on hover
  if (window.PXUTheme.media_queries && window.PXUTheme.media_queries.large.matches) {
    $('body').on('mouseenter', '.cc-swatch', function () {
      var swapImg = $(this).data('swap-image');
      if (swapImg) {
        $('<img/>')[0].src = swapImg;
        $(this).closest('.thumbnail, .js-recently-viewed-product')
               .find('.image__container img:not(.secondary)')
               .attr('src', swapImg)
               .attr('srcset', swapImg);
      }
    });
  }

  // Scroll arrow: slide the swatch strip right to reveal more colors
  $('body').on('click', '.cc-swatch-arrow', function () {
    var $strip = $(this).siblings('.cc-swatch-strip');
    $strip.scrollLeft($strip.scrollLeft() + 100);
  });
});
